// removed by extract-text-webpack-plugin
module.exports = {"title":"wmf-1sUqNbof","search":"wmf-q5UpeeoQ","alert":"wmf-24D_w5TI","table":"wmf-2SKzWQQB","fs_14":"wmf-XrpizolW","ft_bold":"wmf-1W4Tc9YX","color_red":"wmf-1QDttiuV","replaceFooter":"wmf-3SyMvetI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/statementPaymentProgress/index.module.less
// module id = 4748
// module chunks = 0